import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import PasswordModal from '../resetPassword';
import { useAuth } from '../../Utils/Auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AccountsService from '../../Services/AccountsService';
import { useEffect } from 'react';

// Premium 3D avatars
const avatars = [
    { id: 'avatar1', src: 'https://cdn3d.iconscout.com/3d/premium/thumb/man-avatar-6299539-5187871.png' },
    { id: 'avatar4', src: 'https://cdn3d.iconscout.com/3d/premium/thumb/businessman-avatar-6299545-5187877.png' },
    { id: 'avatar2', src: 'https://cdn3d.iconscout.com/3d/premium/thumb/woman-avatar-6299541-5187873.png' },
    //   { id: 'avatar3', src: 'https://cdn3d.iconscout.com/3d/premium/thumb/gamer-avatar-6299543-5187875.png' },
    //   { id: 'avatar_doctor_3d', src: 'https://i.imgur.com/7JZg0ZP.png' },
    //   { id: 'avatar6', src: 'https://i.imgur.com/FSOfHQE.png' }
];

const MyProfile = () => {
    const [user, setUser] = useState({
        name: 'Alex Johnson',
        username: 'alexj',
        role: 'VIP Member',
        liveBalance: 0.00,
        paymentDoneLifetime: 0.00,
        currentDue: 0.00,
        avatar: 'avatar1',
        adminIntropercentage: 0,
        showAdminIntroPercentage: false,
    });
    const [showAvatarModal, setShowAvatarModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [activeTab, setActiveTab] = useState('overview');
    const [isLoading, setIsLoading] = useState(false);
    const auth = useAuth();
    const navigate = useNavigate();

    const handleAvatarSelect = (avatarId) => {
        setIsLoading(true);
        setTimeout(() => {
            setUser({ ...user, avatar: avatarId });
            setShowAvatarModal(false);
            setIsLoading(false);
        }, 800);
    };

    const getCurrentAvatar = () => {
        return avatars.find(avatar => avatar.id === user.avatar)?.src || avatars[0].src;
    };

    const handleLogout = () => {
        const response = window.confirm(
            "Are you sure that you want to Logout from this site ?"
        );
        if (response) {
            toast.success("Logout Successfully");
            auth.logout();
            navigate("/");
        }
    }

    useEffect(() => {
        AccountsService.getprofile(auth.user)
            .then((res) => {
                setUser((state) => ({
                    ...state,
                    name: `${res?.data?.data?.firstName ?? ""} ${res?.data?.data?.lastName ?? ""}`,
                    username: res?.data?.data?.userName ?? "",
                    role: "Introducer",
                    liveBalance: res?.data?.data?.liveBalance ?? 0,
                    paymentDoneLifetime: res?.data?.data?.lifeTimePayment ?? 0,
                    currentDue: res?.data?.data?.currentDue ?? 0,
                    totalCharge: res?.data?.data?.totalCharge ?? 0,
                    totalDepositCharge: res?.data?.data?.totalDepositCharge ?? 0,
                    withdrawPercentage: res?.data?.data?.withdrawPercentage ?? 0,
                    depositPercentage: res?.data?.data?.depositPercentage ?? 0,
                    totalWithdrawCharge: res?.data?.data?.totalWithdrawCharge ?? 0,
                    adminIntropercentage: res?.data?.data?.adminIntropercentage ?? 0,
                    showAdminIntroPercentage: res?.data?.data?.showAdminIntroPercentage ?? false,
                }));
            })
            .catch((err) => {
                console.error("Failed to fetch profile:", err);
                // optional: show a toast or fallback UI
                // toast.error("Unable to load profile. Please try again later.");
            });
    }, [auth]);


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="profile-app"
        >
            <Container className="profile-container">
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={8} xl={6}>
                        {/* Main MyProfile Card - Neomorphic Design */}
                        <motion.div
                            className="profile-card"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.6 }}
                            whileHover={{ y: -5 }}
                        >
                            {/* MyProfile Header */}
                            <div className="profile-header">
                                <motion.div
                                    className="avatar-container"
                                    onClick={() => setShowAvatarModal(true)}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <img
                                        src={getCurrentAvatar()}
                                        alt="User Avatar"
                                        className="profile-avatar"
                                    />
                                    <div className="avatar-badge">
                                        <i className="fas fa-camera"></i>
                                    </div>
                                </motion.div>

                                <div className="profile-info">
                                    <div className="profile-name-row">

                                        <motion.h2
                                            className="profile-name"
                                            initial={{ x: -10, opacity: 0 }}
                                            animate={{ x: 0, opacity: 1 }}
                                            transition={{ delay: 0.2 }}
                                        >
                                            {user.name}
                                        </motion.h2>

                                    </div>
                                    <motion.p
                                        className="profile-username"
                                        initial={{ x: -10, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        transition={{ delay: 0.3 }}
                                    >
                                        @{user.username}

                                        {Number(user.showAdminIntroPercentage) === 1 &&
                                            Number(user.adminIntropercentage) > 0 && (
                                                <>
                                                    {" - "}
                                                    <span className="admin-intro-percentage">
                                                        {Number(user.adminIntropercentage)}%
                                                    </span>
                                                </>
                                            )}
                                    </motion.p>
                                    <motion.span
                                        className="profile-role"
                                        initial={{ y: 10, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        transition={{ delay: 0.4 }}
                                    >
                                        <i className="fas  fa-check-circle"></i>   {user.role}
                                    </motion.span>
                                </div>
                            </div>

                            {/* Navigation Tabs */}
                            <motion.div
                                className="profile-tabs"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.5 }}
                            >
                                <button
                                    className={`tab-button ${activeTab === 'overview' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('overview')}
                                >
                                    <i className="fas fa-chart-pie"></i> Overview
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'stats' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('stats')}
                                >
                                    <i className="fas fa-chart-line"></i> Stats
                                </button>

                                <button
                                    className={`tab-button ${activeTab === 'settings' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('settings')}
                                >
                                    <i className="fas fa-cog"></i> Account
                                </button>

                                <button
                                    className={`tab-button ${activeTab === 'charges' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('charges')}
                                >
                                    <i className="fas fa-money-bill-wave"></i> Charges
                                </button>

                            </motion.div>

                            {/* Tab Content */}
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={activeTab}
                                    className="tab-content"
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {activeTab === 'overview' && (
                                        <div className="overview-content">
                                            <motion.div
                                                className="stat-card"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.2 }}
                                                whileHover={{ y: -3 }}
                                            >
                                                <div className="stat-icon">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Live Balance</h5>
                                                    <p className="text-success">  {user.liveBalance.toLocaleString()}</p>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                className="stat-card"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.3 }}
                                                whileHover={{ y: -3 }}
                                            >
                                                <div className="stat-icon">
                                                    <i className="fas fa-history"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Lifetime Payments</h5>
                                                    <p> {user.paymentDoneLifetime.toLocaleString()}</p>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                className="stat-card"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.4 }}
                                                whileHover={{ y: -3 }}
                                            >
                                                <div className="stat-icon">
                                                    <i className="fas fa-exclamation-circle"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Current Due</h5>
                                                    <p
                                                        className={
                                                            Number(user.currentDue) < 0
                                                                ? "current-due-negative"
                                                                : "current-due-positive"
                                                        }
                                                    >
                                                        {Number(user.currentDue).toLocaleString()}
                                                    </p>
                                                </div>
                                            </motion.div>
                                        </div>
                                    )}

                                    {activeTab === 'stats' && (
                                        <div className="stats-content">
                                            <motion.div
                                                className="progress-card"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.2 }}
                                            >
                                                <div className="progress-header">
                                                    <h5>Account Activity</h5>
                                                    <span>75%</span>
                                                </div>
                                                <div className="progress-bar-container">
                                                    <motion.div
                                                        className="progress-bar"
                                                        initial={{ width: 0 }}
                                                        animate={{ width: '75%' }}
                                                        transition={{ duration: 1 }}
                                                    ></motion.div>
                                                </div>
                                            </motion.div>

                                            <motion.div
                                                className="progress-card"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.3 }}
                                            >
                                                <div className="progress-header">
                                                    <h5>Payment History</h5>
                                                    <span>92%</span>
                                                </div>
                                                <div className="progress-bar-container">
                                                    <motion.div
                                                        className="progress-bar"
                                                        initial={{ width: 0 }}
                                                        animate={{ width: '92%' }}
                                                        transition={{ duration: 1, delay: 0.2 }}
                                                    ></motion.div>
                                                </div>
                                            </motion.div>
                                        </div>
                                    )}

                                    {activeTab === 'settings' && (
                                        <div className="settings-content">
                                            <motion.button
                                                className="settings-button"
                                                whileHover={{ x: 5 }}
                                                whileTap={{ scale: 0.98 }}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.3 }}
                                                onClick={() => navigate("/statement")}
                                            >
                                                <i className="fas fa-file-alt wth-bg"></i>My Statement
                                            </motion.button>

                                            <motion.button
                                                className="settings-button"
                                                whileHover={{ x: 5 }}
                                                whileTap={{ scale: 0.98 }}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.3 }}
                                                onClick={() => navigate("/user-statement")}
                                            >
                                                <i className="fas fa-file-alt wth-bg"></i>My User's Statement
                                            </motion.button>

                                            <motion.button
                                                className="settings-button"
                                                whileHover={{ x: 5 }}
                                                whileTap={{ scale: 0.98 }}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.4 }}
                                                onClick={() => navigate("/mynetworks")}
                                            >
                                                <i className="fas fa-user-friends wth-bg"></i> My Network
                                            </motion.button>

                                            <motion.button
                                                className="settings-button"
                                                whileHover={{ x: 5 }}
                                                whileTap={{ scale: 0.98 }}
                                                onClick={() => setShowPasswordModal(true)}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.2 }}
                                            >
                                                <i className="fas fa-key wth-bg"></i> Change Password
                                            </motion.button>


                                            <motion.button
                                                className="settings-button"
                                                whileHover={{ x: 5 }}
                                                whileTap={{ scale: 0.98 }}
                                                onClick={() => handleLogout()}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ delay: 0.2 }}
                                            >
                                                <i className="fas fa-sign-out-alt wth-bg"></i> Log Out
                                            </motion.button>


                                        </div>
                                    )}
                                    {activeTab === 'charges' && (
                                        <div className="overview-content">

                                            <motion.div className="stat-card">
                                                <div className="stat-icon">
                                                    <i className="fas fa-wallet"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Total Charges</h5>
                                                    <p className="text-success">  {user.totalCharge?.toLocaleString()}</p>

                                                </div>
                                            </motion.div>
                                            <motion.div className="stat-card">
                                                <div className="stat-icon">
                                                    <i className="fas fa-arrow-down"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Deposit Charges ({user.depositPercentage?.toLocaleString()}%)</h5>
                                                    <p className="text-success">  {user.totalDepositCharge?.toLocaleString()}</p>
                                                </div>
                                            </motion.div>

                                            <motion.div className="stat-card">
                                                <div className="stat-icon">
                                                    <i className="fas fa-arrow-up"></i>
                                                </div>
                                                <div className="stat-details">
                                                    <h5>Withdraw Charges ({user.withdrawPercentage?.toLocaleString()}%)</h5>
                                                    <p className="text-success">  {user.totalWithdrawCharge?.toLocaleString()}</p>
                                                </div>
                                            </motion.div>

                                        </div>
                                    )}
                                </motion.div>
                            </AnimatePresence>
                        </motion.div>
                    </Col>
                </Row>
            </Container>

            {/* Avatar Selection Modal */}
            <Modal
                show={showAvatarModal}
                onHide={() => setShowAvatarModal(false)}
                centered
                className="avatar-modal"
            >
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="modal-content"
                >
                    {/* <Modal.Header closeButton>
                        <Modal.Title>Select Your Avatar</Modal.Title>
                    </Modal.Header> */}
                    <Modal.Body>
                        <Row className="g-3">
                            {avatars.map((avatar) => (
                                <Col xs={4} sm={4} key={avatar.id}>
                                    <motion.div
                                        className={`avatar-option ${user.avatar === avatar.id ? 'selected' : ''}`}
                                        onClick={() => handleAvatarSelect(avatar.id)}
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.9 }}
                                    >
                                        <img
                                            src={avatar.src}
                                            alt={`Avatar ${avatar.id}`}
                                            className="img-fluid"
                                        />
                                    </motion.div>
                                </Col>
                            ))}
                        </Row>
                    </Modal.Body>
                </motion.div>
            </Modal>

            {/* Password Reset Modal */}
            <PasswordModal
                show={showPasswordModal}
                onHide={() => setShowPasswordModal(false)}
                isLoading={isLoading}
            />
        </motion.div>
    );
};



export default MyProfile;